import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RELATED_REPORT } from '../../constant';

type Payload = {
  uhid: string;
  hospitalId: string;
  limit: number;
  page: number;
};

export const getRelatedReportApi = createAsyncThunk(
  'getRelatedReports',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(`${RELATED_REPORT.GET_PATIENT_PRESCRIPTION}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Get Prescription failed');
      }

      const result = await response.json();

      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
